import { FC } from "react";
import * as Styled from "./Toggle.styled";
type ToggleProps = {
  id: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  name?: string;
};
export const Toggle: FC<ToggleProps> = ({
  id,
  checked,
  onChange,
  disabled = false,
  name
}) => {
  return <Styled.ToggleSwitch data-sentry-element="unknown" data-sentry-component="Toggle" data-sentry-source-file="index.tsx">
            <input id={id} name={name} type="checkbox" checked={checked} onChange={onChange} disabled={disabled} />
            <span className="slider round"></span>
        </Styled.ToggleSwitch>;
};